/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerGetMyRunQueryResponse, TransfersControllerGetMyRunQueryParams, TransfersControllerGetMyRun400, TransfersControllerGetMyRun401, TransfersControllerGetMyRun403, TransfersControllerGetMyRun404 } from "../../models/transfersController/TransfersControllerGetMyRun";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transfersControllerGetMyRun } from "../../clients/transfersService/transfersControllerGetMyRun";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transfersControllerGetMyRunQueryKey = (params: TransfersControllerGetMyRunQueryParams) => [{
  url: '/api/v1/transfers/my-runs'
}, ...(params ? [params] : [])] as const;
export type TransfersControllerGetMyRunQueryKey = ReturnType<typeof transfersControllerGetMyRunQueryKey>;
export function transfersControllerGetMyRunQueryOptions(params: TransfersControllerGetMyRunQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transfersControllerGetMyRunQueryKey(params);
  return queryOptions<TransfersControllerGetMyRunQueryResponse, ResponseErrorConfig<TransfersControllerGetMyRun400 | TransfersControllerGetMyRun401 | TransfersControllerGetMyRun403 | TransfersControllerGetMyRun404>, TransfersControllerGetMyRunQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transfersControllerGetMyRun(params, config);
    }
  });
}

/**
 * @summary Get my organization transfer run status
 * {@link /api/v1/transfers/my-runs}
 */
export function useTransfersControllerGetMyRun<TData = TransfersControllerGetMyRunQueryResponse, TQueryData = TransfersControllerGetMyRunQueryResponse, TQueryKey extends QueryKey = TransfersControllerGetMyRunQueryKey>(params: TransfersControllerGetMyRunQueryParams, options: {
  query?: Partial<QueryObserverOptions<TransfersControllerGetMyRunQueryResponse, ResponseErrorConfig<TransfersControllerGetMyRun400 | TransfersControllerGetMyRun401 | TransfersControllerGetMyRun403 | TransfersControllerGetMyRun404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transfersControllerGetMyRunQueryKey(params);
  const query = useQuery({
    ...transfersControllerGetMyRunQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransfersControllerGetMyRun400 | TransfersControllerGetMyRun401 | TransfersControllerGetMyRun403 | TransfersControllerGetMyRun404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}